query GetInvestmentPools {
  investmentPools {
    id
    name
    isActive
    accountNumber
    salesforceId
    legalEntity {
      id
      name
    }
    currency
    opexFloatFundAccount {
      id
      fund {
        id
        name
        legalEntity {
          id
          name
        }
      }
      currency
    }
  }
}
